import { UserDetailsPage } from "~/domain/common";
import { DsmNavigation } from "../../DsmNavigation";

export function DsmUserDetailsPage() {
  return <UserDetailsPage navigation={<DsmNavigation />} />;
}
